<template>
    <div id="layout-with-top-navigation">
        <header :class="isFixed ? 'is-fixed' : ''">
            <layout-part-top-configuration :display-trigger="false" />
            <mobile-navigation-top />
            <nav id="top-navigation">
                <router-link :to="{name: 'home'}" class="nav-item logo">
                    <span class="icon-logo-manitou"></span>
                </router-link>
                <router-link
                    v-for="(navigationItem, index) in navigationItems"
                    :key="index"
                    :to="navigationItem.route"
                    class="nav-item link-icon"
                    :class="{active: $route.meta.navigationActive === navigationItem.type, 'coming-soon': navigationItem.comingSoon}"
                    :data-tracking="navigationItem.type.includes('compare') ? 'button__compare' : ''"
                >
                    <span class="icon-container">
                        <span :class="[navigationItem.icon, brandColor]"></span>
                    </span>
                    <span class="title">
                        <span class="title-text">{{ navigationItem.title }}</span>
                        <span class="coming-soon" v-if="navigationItem.comingSoon">{{ navigationItem.subtitle }}</span>
                    </span>
                    <span class="bottom-line" :class="brandBackgroundColor"></span>
                </router-link>
                <a href="javascript:;" class="nav-item trigger-top-configuration" @click="$store.commit('settings/toggleDisplayTopConfiguration')">
                    <span class="icon-cogwheel"></span>
                </a>
            </nav>
        </header>
        <vue-tour></vue-tour>

        <slot></slot>

        <mobile-navigation-bottom :class="{'collapsed' : $route.matched.some(({ name }) => name === 'compare-comparison')}"  />
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    import LayoutPartTopConfiguration from "@/components/LayoutPart/LayoutPartTopConfiguration.vue"
    import MobileNavigationTop from "@/components/MobileNavigation/MobileNavigationTop.vue"
    import MobileNavigationBottom from "@/components/MobileNavigation/MobileNavigationBottom.vue"
    import VueTour from "@/components/OnBoarding/VueTour";

    export default {
        name: 'WithTopNavigationLayout',
        components:{
            LayoutPartTopConfiguration,
            MobileNavigationTop,
            MobileNavigationBottom,
            VueTour
        },
      data() {
          return {
          isCollapsed:false,
        }
      },
        computed: {
            ...mapState({
                navigationItems: state => state.settings.navigationItems,
            }),
            viewsTransition() {
                return this.$route.meta.viewsTransition;
            },
            isFixed() {
              return this.$route.name === 'search-innovations';
            }
        }
    }
</script>


<style lang="scss">
    #layout-with-top-navigation {
        position: relative;
        padding-top: $top-navigation-height;

        @media #{$mq_phone} {
            padding-top: 0;
            padding-bottom: $mobile-bottom-navigation;

            header.is-fixed {
              position: fixed;
              width: 100%;
              z-index: 1000;
              background: #fff;
            }
        }

        #top-navigation {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 10;
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: $top-navigation-height;
            background-color: $blackish;

            @media #{$mq_phone} {
                display: none;
            }

            .nav-item {
                display: flex;
                height: 100%;
                align-items: center;
                justify-content: center;
                border-right: 2px solid $dark-slate-gray;

                &:last-child {
                    border-right: none;
                }

                &.coming-soon {
                  display: none;
                }

                &.logo {
                    width: 156px;
                    font-size: 24px;
                    color: $white;
                }

                &.link-icon {
                    position: relative;
                    flex: 1 1 auto;

                    &:hover, &.active {
                        .bottom-line {
                            opacity: 1;
                        }
                    }

                    .bottom-line {
                        opacity: 0;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        height: 7px;
                        transition: opacity 0.3s ease;
                    }

                    .icon-container {
                        position: relative;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        width: 46px;
                        height: 46px;
                        background-color: #333333;
                        border-radius: 1000px;

                        @media #{$mq_phone} {
                            width: 32px;
                            height: 32px;
                        }

                        [class^="icon-"], [class*=" icon-"] {
                            &.icon-target {
                                font-size: 20px;

                                @media #{$mq_phone} {
                                    font-size: 15px;
                                }
                            }

                            &.icon-search {
                                font-size: 18px;

                                @media #{$mq_phone} {
                                    font-size: 15px;
                                }
                            }

                            &.icon-compare {
                                margin-top: 2px;
                                font-size: 24px;

                                @media #{$mq_phone} {
                                    font-size: 17px;
                                }
                            }

                            &.icon-formation {
                                margin-top: 4px;
                                font-size: 24px;

                                @media #{$mq_phone} {
                                    font-size: 17px;
                                }
                            }
                        }
                    }

                    .title {
                        margin-left: 20px;

                        .title-text {
                            display: block;
                            font-size: 16px;
                            color: $white;
                        }

                        .coming-soon {
                            display: block;
                            font-size: 11px;
                            font-weight: 700;
                            margin-top: 5px;
                            color: #7e7e7e;
                        }
                    }
                }

                &.trigger-top-configuration {
                    width: 80px;
                    font-size: 26px;
                    color: $white;

                    [class^="icon-"], [class*=" icon-"] {
                        transform: scale(1);
                        transition: transform 0.3s ease;
                    }

                    &:hover {
                        [class^="icon-"], [class*=" icon-"] {
                            transform: scale(1.2);
                        }
                    }
                }
            }
        }
    }
</style>